export default "__VITE_ASSET__2l8gp9qJ__"